// src/pages/Users/Techniques/data/uv2ProgramData.js

export const UV2_GRADE_CONFIG = [
  {
    key: "1dan",
    label: "1er Dan",
    shortLabel: "1er",
    defenseSeries: ["A", "B"],
    draw: {
      nage: 6,
      newaza: 4,
      defense: 2,
    },
  },
  {
    key: "2dan",
    label: "2e Dan",
    shortLabel: "2e",
    defenseSeries: ["C"],
    draw: {
      nage: 2,
      newaza: 2,
      defense: 2,
    },
  },
  {
    key: "3dan",
    label: "3e Dan",
    shortLabel: "3e",
    defenseSeries: ["D"],
    draw: {
      nage: 2,
      newaza: 2,
      defense: 2,
    },
  },
];

export const UV2_RULES = {
  "1dan": {
    title: "UV2 Technique 1er Dan",
    duration: "Durée de l’épreuve : 5 minutes",
    intro:
      "Le candidat démontre 12 techniques issues de l’annexe 1 : 6 en nage-waza, 4 en ne-waza choisies par le jury et 2 techniques de défense au choix du candidat.",
    points: [
      "Les techniques de nage-waza doivent être démontrées en déplacement.",
      "En ne-waza, les techniques doivent être démontrées en situation d’étude.",
      "Les défenses sont choisies parmi les séries A et B des 20 attaques imposées Ju-jitsu.",
      "Les 2 saisies et les 2 réponses doivent être différentes.",
      "Une méconnaissance dans chacun des trois domaines est acceptée.",
    ],
  },

  "2dan": {
    title: "UV2 Technique 2e Dan",
    duration: "Partie libre : 3 à 4 minutes max. Tirage : 5 minutes max.",
    intro:
      "L’épreuve comporte une partie libre et une partie après tirage au sort.",
    points: [
      "Partie A : le candidat démontre une technique en nage-waza, une technique en ne-waza et une technique de défense au choix.",
      "Les techniques sont présentées dans un contexte dynamique : déplacements, enchaînements, situations.",
      "Partie B : tirage de 6 techniques issues de l’annexe 1 : 2 en nage-waza, 2 en ne-waza et 2 défenses.",
      "Les défenses sont choisies parmi la série C des 20 attaques imposées Ju-jitsu.",
      "Si une technique a déjà été démontrée dans la partie A, le jury demande une autre technique.",
    ],
  },

  "3dan": {
    title: "UV2 Technique 3e Dan",
    duration: "Partie libre : 9 minutes max. Tirage : 5 minutes max.",
    intro:
      "L’épreuve comporte une démonstration libre complète puis une démonstration issue de l’annexe 1.",
    points: [
      "Partie A : 3 techniques de nage-waza dans 3 directions différentes.",
      "Partie A : 2 techniques de ne-waza démontrées à partir de situations de combat.",
      "Partie A : des techniques de défense sur saisies, coups et armes.",
      "Partie B : tirage de 6 techniques issues de l’annexe 1 : 2 en nage-waza, 2 en ne-waza et 2 défenses.",
      "Les défenses sont choisies parmi la série D.",
      "Cette UV n’est pas fractionnable.",
    ],
  },
};

export const UV2_PROGRAM_BY_GRADE = {
  "1dan": {
    nage: {
      "Koshi-waza": [
        "haraï-goshi",
        "kubi-nage",
        "koshi-guruma",
        "o-goshi",
        "tsurikomi-goshi",
        "uchi-mata",
        "uki-goshi",
      ],
      "Te-waza": [
        "ippon-seoi-nage",
        "kata-guruma",
        "uki-otoshi",
        "tai-otoshi",
        "morote-seoi-nage",
      ],
      "Ashi-waza": [
        "de-ashi-baraï (haraï)",
        "hiza-guruma",
        "sasae-tsurikomi-ashi",
        "ko-soto-gari",
        "ko-uchi-gari",
        "okuri-ashi-baraï (haraï)",
        "o-soto-gari",
        "o-uchi-gari",
        "uchi-mata",
      ],
      "Sutemi-waza": ["sumi-gaeshi", "tomoe-nage"],
    },

    newaza: {
      "Immobilisations - Osaekomi-waza": [
        "hon-gesa-gatame",
        "kami-shiho-gatame",
        "yoko-shiho-gatame",
        "tate-shiho-gatame",
        "ushiro-gesa-gatame",
      ],
      "Étranglements - Shime-waza": [
        "gyaku-juji-jime",
        "hadaka-jime",
        "kata-juji-jime",
        "nami-juji-jime",
        "okuri-eri-jime",
      ],
      "Clés aux coudes - Kansetsu-waza": [
        "ude-hishigi-juji-gatame",
        "ude-hishigi-ude-gatame",
        "ude-garami",
      ],
    },
  },

  "2dan": {
    nage: {
      "Koshi-waza": ["hane-goshi", "sode-tsurikomi-goshi", "tsuri-goshi"],
      "Te-waza": [
        "eri-seoi-nage",
        "te-guruma",
        "morote-gari",
        "kuchiki-taoshi",
      ],
      "Ashi-waza": [
        "o-guruma",
        "ashi-guruma",
        "ko-soto-gake",
        "o-soto-otoshi",
        "tsubame-gaeshi",
      ],
      "Sutemi-waza": [
        "ura-nage",
        "tani-otoshi",
        "yoko-guruma",
        "yoko-gake",
        "ko-uchi-makikomi",
        "yoko-tomoe-nage",
        "uki-waza",
      ],
    },

    newaza: {
      "Immobilisations - Osaekomi-waza": [
        "kuzure-kami-shiho-gatame",
        "kuzure-gesa-gatame",
        "kuzure-tate-shiho-gatame",
        "kuzure-yoko-shiho-gatame",
      ],
      "Étranglements - Shime-waza": [
        "sankaku-jime",
        "kata-ha-jime",
        "kata-te-jime",
        "sode-guruma-jime",
      ],
      "Clés aux coudes - Kansetsu-waza": [
        "ude-hishigi-hiza-gatame",
        "ude-hishigi-waki-gatame",
      ],
    },
  },

  "3dan": {
    nage: {
      "Koshi-waza": ["utsuri-goshi", "ushiro-goshi"],
      "Te-waza": [
        "sumi-otoshi",
        "kibisu-gaeshi",
        "uchi-mata-sukashi",
        "sukui-nage",
        "yama-arashi",
        "seoi-otoshi",
      ],
      "Ashi-waza": ["haraï-tsurikomi-ashi", "o-soto-guruma", "o-soto-gaeshi"],
      "Sutemi-waza": [
        "soto-makikomi",
        "harai-makikomi",
        "yoko-wakare",
        "yoko-otoshi",
        "tawara-gaeshi",
        "daki-wakare",
      ],
    },

    newaza: {
      "Immobilisations - Osaekomi-waza": ["makura-gesa-gatame", "kata-gatame"],
      "Étranglements - Shime-waza": [
        "morote-jime",
        "tsukkomi-jime",
        "ashi-gatame-jime",
        "ryo-te-jime",
      ],
      "Clés aux coudes - Kansetsu-waza": [
        "ude-hishigi-ashi-gatame",
        "ude-hishigi-sankaku-gatame",
        "ude-hishigi-hara-gatame",
      ],
    },
  },
};

export const UV2_DEFENSE_ATTACKS = {
  A: [
    "Katate-dori",
    "Eri-dori",
    "Mae-kubi-dori",
    "Yoko-kubi-dori",
    "Yoko-sode-dori",
  ],
  B: [
    "Mae-dori",
    "Yoko-dori",
    "Yoko-kubi-dori",
    "Mae-kubi-dori",
    "Hadaka-jime",
  ],
  C: [
    "Uchi-oroshi-tsuki",
    "Chudan-gyaku-tsuki",
    "Jodan-naname-shuto",
    "Chudan-mae-geri-kekomi",
    "Chudan-mawashi-geri",
  ],
  D: [
    "Naname-tsuki",
    "Chudan-tsukkomi",
    "Naname-uchi",
    "Kiri-komi",
    "Yoko-uchi",
  ],
};

// Tu pourras placer les JPG officiels ici dans /public/img/techniques/uv2/
export const UV2_ANNEX_IMAGES = [
  {
    title: "Programme technique UV2",
    src: "/img/uv2/programme-technique-uv2.png",
  },
  {
    title: "20 attaques défenses imposées Ju-jitsu",
    src: "/img/uv2/20_techniques_jujitsu.png",
  },
];
